<base-modal-component class="base-modal">

    <ng-container *ngFor="let id of ids">
        <a [routerLink]="['/order-details']" [queryParams]="{id: id}">{{id}}</a><br/>
    </ng-container>
</base-modal-component>